<ion-content class="customContainer">
  <ion-grid class="subHeader">
    <ion-row class="ion-justify-content-between ion-align-items-center">
      <ion-col size="12" size-sm="4" size-md="4" size-lg="4">
        <ion-toolbar mode="md">
          <!-- <ion-buttons slot="start" class="ion-no-margin" (click)="dismissModal()">
            <ion-icon name="chevron-back-outline"></ion-icon>
          </ion-buttons> -->
          <ion-buttons slot="start" class="ion-no-margin" (click)="dismissModal()">
            <ion-back-button></ion-back-button>
          </ion-buttons>
          <ion-title class="ion-no-padding help-video">{{'HelpVideo' | language : 'Help Video'}}</ion-title>
        </ion-toolbar>
      </ion-col>
    </ion-row>
  </ion-grid>
  <ng-container>
    <ion-list>
      <ng-container *ngFor="let video of helpVideos">
        <ion-label class="ion-margin-vertical ion-margin-start label">
          {{ video.title | language: video.title }}</ion-label>
        <div class="videoPlayer">
          <!-- <youtube-player [videoId]="video.id" [height]="180">
          </youtube-player> -->
        </div>
      </ng-container>
    </ion-list>
  </ng-container>
</ion-content>